import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AnvandareListResponseDTO, User } from "~app/common/models/anvandare/AnvandareListResponseDTO";
import { RedigeraAnvandareComponent } from "../redigera-anvandare/redigera-anvandare.component";

@Component({
    selector: "rask-anvandare-list",
    templateUrl: "./anvandare-list.component.html",
    styleUrls: ["./anvandare-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective
    ]
})
export class AnvandareListComponent {
    @Input() anvandare: AnvandareListResponseDTO[];

    private readonly modalService = inject(NgbModal);

    open = (event: Event, user: User = null) => {
        event.preventDefault();
        if (!this.modalService.hasOpenModals()) {
            const modalRef = this.modalService.open(RedigeraAnvandareComponent, {
                keyboard: false,
                backdrop: "static",
                size: "xl"
            });
            const modal = modalRef.componentInstance as RedigeraAnvandareComponent;
            modal.setUserId(user.userId);
            modalRef.result.then(result => modalRef.close(result), (reason) => {
                // Fånga error
            });
        }
    };
}
